module.exports = __webpack_public_path__ + "static/media/img_about_us.332831b7.webp";